export default __webpack_public_path__ + "static/new_03-ac6e0eddd7370def27394d928baaa01e.webp";